// SyncMetricKeyEnum.ts

export enum SyncMetricKeyEnum {
  studentsMatched = "studentsMatched",
  studentsUnmatched = "studentsUnmatched",
  teachersMatched = "teachersMatched",
  teachersUnmatched = "teachersUnmatched",
  usersUnchanged = "usersUnchanged",
  usersAdded = "usersAdded",
  usersDeleted = "usersDeleted",
  usersUpdated = "usersUpdated",
  groupsUnchanged = "groupsUnchanged",
  groupsAdded = "groupsAdded",
  groupsDeleted = "groupsDeleted",
  groupsUpdated = "groupsUpdated",
  classroomsUnchanged = "classroomsUnchanged",
  classroomsAdded = "classroomsAdded",
  classroomsDeleted = "classroomsDeleted",
  classroomsUpdated = "classroomsUpdated",
  guardiansUnchanged = "guardiansUnchanged",
  guardiansAdded = "guardiansAdded",
  guardiansDeleted = "guardiansDeleted",
  guardiansUpdated = "guardiansUpdated",
  userGroupsAdded = "userGroupsAdded",
  userGroupsDeleted = "userGroupsDeleted",
  userClassroomsAdded = "userClassroomsAdded",
  userClassroomsDeleted = "userClassroomsDeleted",
  userGuardiansAdded = "userGuardiansAdded",
  userGuardiansDeleted = "userGuardiansDeleted",
  groupSubgroupsAdded = "groupSubgroupsAdded",
  groupSubgroupsDeleted = "groupSubgroupsDeleted",
  groupOwnersAdded = "groupOwnersAdded",
  groupOwnersDeleted = "groupOwnersDeleted",
}
